import React from "react";
import { useState, useEffect } from "react";
import Sidebar from "../Components/Sidebar/Sidebar";
import pagination from './pagination';
import "./Stax.css";
import { Roller } from "react-awesome-spinners";
import { old_customers_from_stax, delete_stax_customer } from "../Api/crm";
import Spinner from 'react-bootstrap/Spinner';
import Table from 'react-bootstrap/Table';
import Button from "react-bootstrap/Button";
import { Modal } from 'react-bootstrap';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";


function StaxCleanup() {
    const [loading, setLoading] = useState(false);
    const [staxdata, setStaxdata] = useState([]); 
    const [showConfirm, setShowConfirm] = useState(false);

    const handleCloseConfirm = () => setShowConfirm(false);
    const handleShowConfirm = () => setShowConfirm(true);

    const [totalSize, setTotalSize] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [selectedIds, setSelectedIds] = useState([]);



    //data fr Fetchesom the API and updates the state with the processed data
    const getuserdata = (page, perPage) => {
        setLoading(true);

        const formData = new FormData();
        formData.append("page", page);
        formData.append("perPage", perPage);
        old_customers_from_stax(formData)
            .then((response) => {
                if (response.code === 200) {
                    const apiResponse = response.data;

                    // Check if the API status is success
                    if (apiResponse.status === 1) {
                        const fetchedMargedata = apiResponse.data;

                        // Update the state with the processed data
                        setStaxdata(fetchedMargedata);
                        setTotalSize(apiResponse.total);

                    } else {
                        // Handle error when status is not 1
                        console.error("API returned non-success status:", apiResponse);
                    }
                } else {
                    // Handle invalid response code (not 200)
                    console.error("Invalid response code:", response.code);
                }
            })
            .catch(function (err) {
                // Handle network or unexpected errors
                console.error("Error fetching data:", err);
            })
            .finally(() => {
                // Hide the loading spinner after the request completes
                setLoading(false);
            });
    };

    // Checkbox selection for Bootstrap Table
    const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        getuserdata(page, sizePerPage);
        setPage(page);
        setPerPage(sizePerPage);
    };

    const handleCheckboxChange = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allIds = staxdata.map((item) => item.id).filter(Boolean); // ensure no undefined
            setSelectedIds(allIds);
        } else {
            setSelectedIds([]);
        }
    };

    const [deleteloader, setDeleteloader] = useState(false);

    const startlillypadCleanup = () => {
        handleCloseConfirm();
        setDeleteloader(true);
        const formData = new FormData();
        formData.append("customer_id", selectedIds);
        delete_stax_customer(formData).then((response) => {
            if (response.code === 200) {
                const apiResponse = response.data;
                if (apiResponse.status === 1) {
                    // setDelcount(prevCount => prevCount + 1); 
                    setDeleteloader(false);
                    window.location.reload();
                } else {
                    alert("user delete failed");
                    setDeleteloader(false);
                }
            }
        });
    }

    const columns = [
        {
            dataField: 'select',
            text: (
                <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={selectedIds.length === staxdata.length}
                />
            ),
            formatter: (cellContent, row) => {
                console.log('Render Row ID:', row.id, 'Checked:', selectedIds.includes(row.id));
                return (
                    <input
                        type="checkbox"
                        checked={selectedIds.includes(row.id)}
                        onChange={() => handleCheckboxChange(row.id)}
                    />
                );
            },
            headerStyle: () => ({ width: '60px' }),
        },
        {
            dataField: "stax_id", text: "Stax ID", sort: false,
            formatter: (cell, row) => (
                <a
                    href={`https://app.staxpayments.com/#/customer/${row.stax_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {cell}
                </a>
            ),
        },
        { dataField: "name", text: "Name", sort: false,
            formatter: (cell, row) => (
              `${row.firstname} ${row.lastname}`
            )
         },
        { dataField: "email", text: "Email", sort: false },
        { dataField: "created_at", text: "Create Date", sort: false },
        { dataField: "status", text: "Status", sort: false },
        { dataField: "notes", text: "Notes", sort: false },
        {
            dataField: "actions",
            text: "Actions",
            formatter: (cellContent, row) => (
                <div>
                    {deleteloader ? (
                        <Button variant="success">Deleting...</Button>
                    ) : (
                        <Button variant="danger" onClick={() => {
                            setSelectedIds([row.id]);
                            handleShowConfirm();
                        }}>Delete</Button>
                    )}
                </div>
            )
        }
    ];

    useEffect(() => {
        getuserdata(1, 10);
    }, []);

    return (
        <div>
            {
                loading ? (
                    <div className="loading">
                        <Roller />
                    </div>
                ) : (<>

                    <Modal show={showConfirm} onHide={handleCloseConfirm}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Action</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Are you sure you want to perform this action?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseConfirm}>
                                Cancel
                            </Button>
                            <Button variant="primary" onClick={startlillypadCleanup}>
                                Confirm
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <div className="dashboard-container d-flex">
                        <div className="sidebar-container">
                            <Sidebar />
                        </div>
                        <div className="main-container">
                            <div className="main-page-body-content">
                                {/* <div className="main-page-body-content-header">
                                    <Header />
                                </div> */}
                                <div className="main-page-body-content-body">
                                    <div className="main-page-body-content-body-container">
                                        <div className="container-fulid">
                                            <div className="">
                                                <div className="table-card ">
                                                    <div className="card-body table-card-body">
                                                        <div className="table-card-header">
                                                            <h5 className="card-title">Lillypad data</h5>
                                                        </div>
                                                        <div className="table-card-body-inner">
                                                            <div className="animated fadeIn">
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div className="card">
                                                                            <div className="card-header d-flex justify-content-between table-card-header" >
                                                                                <div className="card-header d-flex table-card-header justify-content-between align-items-center">
                                                                                    <div className="ml-auto d-flex">
                                                                                        {
                                                                                            deleteloader ? (
                                                                                                <Button
                                                                                                    disabled
                                                                                                    className="btn btn-sm float-right add-user-btn ms-0"
                                                                                                >
                                                                                                    Deleting...
                                                                                                </Button>
                                                                                            ) : (
                                                                                                <Button
                                                                                                    onClick={handleShowConfirm}
                                                                                                    className="btn btn-sm float-right add-user-btn ms-0"
                                                                                                >
                                                                                                    Delete User
                                                                                                </Button>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="card-body">

                                                                                {/* <Table striped bordered hover>
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th>#</th>
                                                                                            <th>Stax ID</th>
                                                                                            <th>Name</th>
                                                                                            <th>Email</th>
                                                                                            <th>Create Date</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {staxdata && staxdata.map((item, index) => {
                                                                                            const currentUserIndex = index + 1;
                                                                                            return (
                                                                                                <React.Fragment key={currentUserIndex}>
                                                                                                    {currentUserIndex === currentsatxuserid && currentUserIndex < staxdata.length ? (
                                                                                                        <tr>
                                                                                                            <td colSpan={6} style={{ textAlign: 'center' }}>
                                                                                                                <Spinner
                                                                                                                    as="span"
                                                                                                                    animation="border"
                                                                                                                    size="sm"
                                                                                                                    role="status"
                                                                                                                    aria-hidden="true"
                                                                                                                />
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    ) : (
                                                                                                        <tr id={`user_id_${ currentUserIndex } `}> 
                                                                                                            <td><input
                                                                                                                type="checkbox"
                                                                                                                checked={selectedIds.includes(index)}
                                                                                                                onChange={() => handleCheckboxChange(index)}
                                                                                                            /></td>
                                                                                                            <td>{item.id}</td>
                                                                                                            <td>{item.name}</td>
                                                                                                            <td id={`user_email_${ currentUserIndex } `}>{item.user_email}</td>
                                                                                                            <td>{
                                                                                                                new Date(item.created_at).toLocaleString('en-US', {
                                                                                                                    year: 'numeric',
                                                                                                                    month: '2-digit',
                                                                                                                    day: '2-digit',
                                                                                                                    hour: '2-digit',
                                                                                                                    minute: '2-digit',
                                                                                                                    second: '2-digit',
                                                                                                                })
                                                                                                            }</td>
                                                                                                        </tr>
                                                                                                    )}
                                                                                                </React.Fragment>
                                                                                            );
                                                                                        })}

                                                                                    </tbody>
                                                                                </Table> */}

                                                                                <BootstrapTable
                                                                                    keyField="id"
                                                                                    data={staxdata}
                                                                                    key={selectedIds.join(',')}
                                                                                    columns={columns}
                                                                                    striped
                                                                                    hover
                                                                                    condensed
                                                                                    remote={{ pagination: true }}
                                                                                    pagination={paginationFactory({
                                                                                        page,
                                                                                        sizePerPage: perPage,
                                                                                        totalSize: totalSize,
                                                                                        onPageChange: (p) => setPage(p),
                                                                                        onSizePerPageChange: (size, p) => {
                                                                                            setPerPage(size);
                                                                                            setPage(1);
                                                                                        },
                                                                                        showTotal: true,
                                                                                        sizePerPageList: [
                                                                                            { text: '10', value: 10 },
                                                                                            { text: '25', value: 25 },
                                                                                            { text: '50', value: 50 },
                                                                                        ],
                                                                                    })}
                                                                                    onTableChange={handleTableChange}
                                                                                    noDataIndication={loading ? "Loading..." : "No records found"}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                )}
        </div>
    );
}

export default StaxCleanup;